import { cn } from '@/lib/utils';
import type {
  ButtonBackground,
  ButtonColor,
  ButtonSize,
  ButtonStyle,
} from '@tranquility-ai/theme-components/button';

const primaryNavActionBaseClass = 'tp-primary-navigation__action';

/** Horizontal nav action pill classes — paired with `primary-navigation.css`. */
export const primaryNavActionClassName = (selected: boolean) =>
  cn(
    primaryNavActionBaseClass,
    selected ? 'tp-primary-navigation__action--selected' : 'tp-primary-navigation__action--inactive',
  );

/**
 * Shared Button props for rows inside the drop-down menu panel. `size="lg"`
 * already supplies the comp's 18px label, 24px icon, and 8px gap; only the
 * horizontal padding is overridden, in `primary-navigation.css`.
 */
export const primaryNavMenuButtonProps: {
  style: ButtonStyle;
  color: ButtonColor;
  background: ButtonBackground;
  size: ButtonSize;
} = {
  style: 'text',
  color: 'light',
  background: 'brand',
  size: 'lg',
};

/**
 * Full-width left-aligned row on the blue panel — paired with `primary-navigation.css`.
 * The utilities ride here rather than in the stylesheet so `cn()`'s tailwind-merge
 * replaces the Button's own `justify-center`, which sits in Tailwind's utility layer.
 */
export const primaryNavMenuItemClassName =
  'tp-primary-navigation__menu-item w-full justify-start text-left';

export const primaryNavExternalLinkClassName = (selected?: boolean) =>
  cn(
    primaryNavActionBaseClass,
    selected ? 'tp-primary-navigation__action--selected' : 'tp-primary-navigation__action--inactive',
    'no-underline text-inherit',
  );
